import { render, staticRenderFns } from "./RecipesMobile.vue?vue&type=template&id=59089f67"
import script from "./RecipesMobile.vue?vue&type=script&lang=js"
export * from "./RecipesMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports